// extracted by mini-css-extract-plugin
export var location = "styles-module__location___hAqkh";